import DocumentationButton from "components/DocumentationButton";
import { EmptystateKeyColored } from "components/icons/generated";
import Box from "ds/components/Box";
import LinkButton from "ds/components/Button/LinkButton";
import EmptyState from "ds/components/EmptyState";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";
import { getDocsUrl } from "utils/getDocsUrl";

import { ApiKeysPersonalEmptyVariant } from "./types";

const API_KEYS_DOCS_URL = getDocsUrl("/integrations/personal-api-keys.html");

const EMPTY_STATE_COPY: Record<ApiKeysPersonalEmptyVariant, { title: string; caption: string }> = {
  [ApiKeysPersonalEmptyVariant.TURNED_OFF]: {
    title: "Personal API keys are turned off",
    caption:
      "Personal API keys let everyone in your account use Spacelift from the CLI, Terraform and the API with their own permissions. Each active key uses an API key seat.",
  },
  [ApiKeysPersonalEmptyVariant.NO_KEYS]: {
    title: "No Personal API keys yet",
    caption: "Keys that people in your organization create will appear here.",
  },
};

type ApiKeysPersonalEmptyProps = {
  variant: ApiKeysPersonalEmptyVariant;
};

const ApiKeysPersonalEmpty = ({ variant }: ApiKeysPersonalEmptyProps) => {
  const { title, caption } = EMPTY_STATE_COPY[variant];

  return (
    <Box align="center" justify="center" grow="1">
      <EmptyState title={title} icon={EmptystateKeyColored} caption={caption}>
        <Box gap="medium">
          <DocumentationButton
            to={API_KEYS_DOCS_URL}
            label="Documentation"
            analyticsPage={AnalyticsPageOrganization.OrganizationApiKeys}
          />
          {variant === ApiKeysPersonalEmptyVariant.TURNED_OFF && (
            <LinkButton
              to="/settings/api-keys/settings"
              variant="primary"
              analyticsPage={AnalyticsPageOrganization.OrganizationApiKeys}
              analyticsTitle="Personal API Keys Empty Go To Settings"
            >
              Go to Settings
            </LinkButton>
          )}
        </Box>
      </EmptyState>
    </Box>
  );
};

export default ApiKeysPersonalEmpty;
